import React, { useContext } from 'react';

import { useLayoutContext } from '@contexts/LayoutContext';

import { NavMenu, NwNavIcon } from '@components/_LayoutComponents/Header/NwHeaderUI';

import { getNavClassName, getNavMenuMode } from './NwNavUtils';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const NwNavBarBookingMobile = ({
    allLogs,
    createNewItemMenu,
    current,
    drawer,
    handleChangeOpenKeys,
    handleClick,
    isLoaded,
    isOpen,
    lastSeenMenu,
    openKeys,
}) => {
    const layoutContext = useLayoutContext();
    const { breakpoints } = layoutContext;

    const navItems = [
        { key: '/dashboard', label: 'Dashboard', disabled: !isLoaded },
        {
            key: '/models',
            label: 'Models',
            disabled: !isLoaded,
        },
        {
            key: '/menu-schedule',
            label: 'Bookings',
            popupClassName: !isOpen('/menu-schedule')
                ? 'main-nav-submenu menu-disabled'
                : 'main-nav-submenu menu-double',
            disabled: !isLoaded,
            onTitleClick: () => handleClick({ key: '/schedule' }),
            children: [
                {
                    type: 'group',
                    key: `/menu-tools-projects`,
                    label: (
                        <span className="submenu-title-wrapper">
                            <NwNavIcon icon={byPrefixAndName.fasl['bolt']} />
                            Tools
                        </span>
                    ),
                    children: [
                        {
                            key: '/schedule',
                            label: (
                                <div className="nw-main-nav-subitems">
                                    <NwNavIcon icon={byPrefixAndName.fasl['calendar']} />
                                    Schedule
                                </div>
                            ),
                        },
                        {
                            key: '/events-search',
                            label: (
                                <div className="nw-main-nav-subitems">
                                    <NwNavIcon icon={byPrefixAndName.fasl['business-time']} />
                                    Events Search
                                </div>
                            ),
                        },
                        {
                            key: '/events-report',
                            label: (
                                <div className="nw-main-nav-subitems">
                                    <NwNavIcon icon={byPrefixAndName.fasl['file-spreadsheet']} />
                                    Events Report
                                </div>
                            ),
                        },
                        {
                            key: '/show-seasons',
                            label: (
                                <div className="nw-main-nav-subitems">
                                    <NwNavIcon icon={byPrefixAndName.fasl['calendar-star']} />
                                    Show Seasons
                                </div>
                            ),
                        },
                    ],
                },
                createNewItemMenu('Project'),
            ],
        },
        {
            key: '/customers',
            label: 'Contacts',
            disabled: !isLoaded,
        },
        // {
        //     key: "/menu-models",
        //     label: "Models",
        //     popupClassName: !isOpen('/menu-models') ? 'main-nav-submenu menu-disabled' : 'main-nav-submenu menu-double',
        //     disabled: !isLoaded,
        //     children: [
        //         {
        //             type: "group",
        //             key: `/menu-tools-models`,
        //             label: (
        //                 <span className="submenu-title-wrapper">
        //                     <NwNavIcon icon={byPrefixAndName.fasl['bolt']} />Tools
        //                 </span>
        //             ),
        //             children: [
        //                 {
        //                     key: '/models',
        //                     label: (
        //                         <div className="nw-main-nav-subitems">
        //                             <NwNavIcon icon={byPrefixAndName.fasl['radar']} />Browse Models
        //                         </div>
        //                     )
        //                 },
        //                 {
        //                     key: '/models-archive',
        //                     label: (
        //                         <div className="nw-main-nav-subitems">
        //                             <NwNavIcon icon={byPrefixAndName.fasl['archive']} />Models Archive
        //                         </div>
        //                     )
        //                 },
        //                 {
        //                     key: '/models-legal',
        //                     disabled: !ViewModelLegals,
        //                     label: (
        //                         <div className="nw-main-nav-subitems">
        //                             <NwNavIcon icon={byPrefixAndName.fasl['passport']} />Models Documents Search
        //                         </div>
        //                     )
        //                 },
        //                 {
        //                     key: '/rooms/chart',
        //                     label: (
        //                         <div className="nw-main-nav-subitems">
        //                             <NwNavIcon icon={byPrefixAndName.fasl['house-user']} />Rooms Management
        //                         </div>
        //                     )
        //                 }
        //             ]
        //         },
        //         createNewItemMenu('Model')
        //     ]
        // },
        // {
        //     key: "/menu-schedule",
        //     label: "Bookings",
        //     popupClassName: !isOpen('/menu-schedule') ? 'main-nav-submenu menu-disabled' : 'main-nav-submenu menu-double',
        //     disabled: !isLoaded,
        //     children: [
        //         {
        //             type: "group",
        //             key: `/menu-tools-projects`,
        //             label: (
        //                 <span className="submenu-title-wrapper">
        //                     <NwNavIcon icon={byPrefixAndName.fasl['bolt']} />Tools
        //                 </span>
        //             ),
        //             children: [
        //                 {
        //                     key: '/schedule',
        //                     label: (
        //                         <div className="nw-main-nav-subitems">
        //                             <NwNavIcon icon={byPrefixAndName.fasl['calendar']} />Schedule
        //                         </div>
        //                     )
        //                 },
        //                 {
        //                     key: '/events-search',
        //                     label: (
        //                         <div className="nw-main-nav-subitems">
        //                             <NwNavIcon icon={byPrefixAndName.fasl['business-time']} />Events Search
        //                         </div>
        //                     )
        //                 },
        //                 {
        //                     key: '/events-report',
        //                     label: (
        //                         <div className="nw-main-nav-subitems">
        //                             <NwNavIcon icon={byPrefixAndName.fasl['file-spreadsheet']} />Events Report
        //                         </div>
        //                     )
        //                 }
        //             ]
        //         },
        //         createNewItemMenu('Project')
        //     ]
        // },
        // {
        //     key: "/menu-contacts",
        //     label: "Contacts",
        //     popupClassName: !isOpen('/menu-contacts') ? 'main-nav-submenu menu-disabled' : 'main-nav-submenu menu-double',
        //     disabled: !isLoaded,
        //     children: [
        //         {
        //             type: "group",
        //             key: `/menu-tools-contacts`,
        //             label: (
        //                 <span className="submenu-title-wrapper">
        //                     <NwNavIcon icon={byPrefixAndName.fasl['bolt']} />Tools
        //                 </span>
        //             ),
        //             children: [
        //                 {
        //                     key: '/customers',
        //                     label: (
        //                         <div className="nw-main-nav-subitems">
        //                             <NwNavIcon icon={byPrefixAndName.fasl['radar']} />Browse Contacts
        //                         </div>
        //                     )
        //                 },
        //                 {
        //                     key: '/customers-archive',
        //                     label: (
        //                         <div className="nw-main-nav-subitems">
        //                             <NwNavIcon icon={byPrefixAndName.fasl['archive']} />Customers Archive
        //                         </div>
        //                     )
        //                 },
        //                 {
        //                     key: '/mailing-lists' || '/mailing-lists/:mailingListId',
        //                     label: (
        //                         <div className="nw-main-nav-subitems">
        //                             <NwNavIcon icon={byPrefixAndName.fasl['mailbox']} />Mailing List
        //                         </div>
        //                     )
        //                 },
        //             ]
        //         },
        //         createNewItemMenu('Customer'),
        //     ]
        // }
    ];

    const keysWithSubmenus = navItems.filter((item) => item.children).map((item) => item.key);

    return (
        <NavMenu
            className={getNavClassName(breakpoints, navItems.length)}
            inlineIndent={10}
            items={navItems}
            mode={getNavMenuMode(drawer, breakpoints)}
            onClick={handleClick}
            onOpenChange={(k) => handleChangeOpenKeys(k, keysWithSubmenus)}
            openKeys={openKeys}
            selectedKeys={[current]}
        />
    );
};

export default NwNavBarBookingMobile;
